import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.adminLogin(password);
      toast.success("Welcome back 💋");
      if (onSuccess) onSuccess();
      nav("/admin");
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="eyebrow justify-center mx-auto mb-4">Admin</div>
          <h1 className="font-display text-5xl text-gold">Camilla XXX</h1>
          <p className="text-ivory-dim mt-2 text-sm">Sign in to manage the site.</p>
        </div>
        <form
          onSubmit={submit}
          className="card-luxe p-6 space-y-4"
          data-testid="admin-login-form"
        >
          <label className="block">
            <span className="text-[0.7rem] uppercase tracking-[0.22em] text-[color:var(--muted)]">
              Password
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-luxe mt-2"
              placeholder="Enter admin password"
              autoFocus
              data-testid="admin-password-input"
            />
          </label>
          <button
            type="submit"
            className="btn-gold w-full"
            disabled={busy || !password}
            data-testid="admin-login-submit"
          >
            {busy ? "..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
